import {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ImageGalleryHolder from 'core/components/image-gallery/ImageGalaryHolder';
import DesignMgmt from './DesignMgmt';
import { setProductassetDashboardProductassetList } from 'store/slice/PharmaSlice';
import { getProductassetInfoByProductidAPI } from 'components/productasset/ProductassetAPI';
import { setProductassetList } from 'store/slice/PharmaSlice';

export default function UploaddesignActionImpl(){
    const dispatch = useDispatch();
    const { integratedImage } = useSelector((state) => state.imagegalleryslice);
    const {productassetList, productDashboard} = useSelector((state) => state.pharmaslice);
    const {productObj } = useSelector((state) => state.pharmaslice.productDashboard);

    const getProductAssetListSuccess = (list) =>{dispatch(setProductassetDashboardProductassetList(list));}
    useEffect(()=>{
        console.log('>>>>>>>>>. UploaddesignActionImpl');
       // getProductassetInfoByProductidAPI(productObj.id, getProductAssetListSuccess, ()=>{});
    },[])
    
    return (
        <>
        <DesignMgmt/>
       {/* {integratedImage!==''? <DesignMgmt/>:<ImageGalleryHolder/>} */}
        </>
    )
}